import * as t from 'io-ts';
import { NonEmptyString } from 'io-ts-types';
import { fromEnum } from '../../responseUtil';

export enum ApiServiceOrderBulkUpdatePreviewErrorCode {
    UNKNOWN_ORDER = 'unknown-order',
    UNSUPPORTED_ORDER_TYPE = 'unsupported-order-type',
    CANCELLED = 'cancelled',
    FINALIZED = 'finalized',
    OTHER_SUPPLIER = 'other-supplier',
}

export const ServiceOrderBulkSelectionCodec = t.type({
    order_ids: t.array(NonEmptyString),
});

const ServiceOrderPreviewCodec = t.intersection([
    t.type({
        id: NonEmptyString,
    }),
    t.partial({
        started_at: NonEmptyString,
        completed_at: NonEmptyString,
        general_information: NonEmptyString,
    }),
]);

const ServiceOrderBulkUpdatePreviewErrorCodec = t.type({
    error_code: fromEnum<ApiServiceOrderBulkUpdatePreviewErrorCode>(
        'ApiServiceOrderBulkUpdatePreviewErrorCode',
        ApiServiceOrderBulkUpdatePreviewErrorCode,
    ),
    order_ids: t.array(NonEmptyString),
});

export const ServiceOrderBulkUpdatePreviewCodec = t.type({
    service_orders: t.array(ServiceOrderPreviewCodec),
    invalid_orders: t.array(ServiceOrderBulkUpdatePreviewErrorCodec),
});

export type ApiServiceOrderBulkSelection = t.TypeOf<typeof ServiceOrderBulkSelectionCodec>;
export type ApiServiceOrderBulkUpdatePreview = t.TypeOf<typeof ServiceOrderBulkUpdatePreviewCodec>;
export type ApiServiceOrderBulkUpdatePreviewError = t.TypeOf<typeof ServiceOrderBulkUpdatePreviewErrorCodec>;
export type ApiServiceOrderPreview = t.TypeOf<typeof ServiceOrderPreviewCodec>;
